import React from 'react';
import {
	LegacyFormTextField,
	type LegacyFormTextFieldProps,
} from '@netx/core-components/Form/TextField';
import type {ICustomFormItem} from '../../types';
import {
	getCustomFormItemTranslatedLabel,
	getCustomFormBaseFieldName,
} from '../../utils';

export interface LegacyFormCustomFormItemTextProps
	extends Omit<
		LegacyFormTextFieldProps,
		'multiline' | 'name' | 'label' | 'required'
	> {
	item: ICustomFormItem<'text' | 'textarea'>;
}

export const LegacyFormCustomFormItemTextPrimitive = ({
	item,
	...props
}: LegacyFormCustomFormItemTextProps) => {
	const {label, type, required} = item;

	return (
		<LegacyFormTextField
			fullWidth
			{...props}
			label={getCustomFormItemTranslatedLabel(label)}
			multiline={type === 'textarea'}
			name={getCustomFormBaseFieldName(item)}
			required={required}
		/>
	);
};

export const LegacyFormCustomFormItemText =
	LegacyFormCustomFormItemTextPrimitive;

export default LegacyFormCustomFormItemText;
